export const AFFILIATE_PROFILE_CONTACTS_ROUTE_NAME = Symbol('admin.affiliates.approved.profile.contacts');
export const TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS = Symbol('admin.affiliates.approved.profile.contacts');
